export default __webpack_public_path__ + "static/media/our-story-mobile-hero.cf8993aa.png";